export * from './ResourceDetailsTemplate';
